import React from "react";
import Pagination from "@mui/material/Pagination";

/**
 * MUI Pagination plus the "Showing X–Y of N" line, which the existing pages
 * omit — without it there is no way to tell a 10-row page of 10 from a 10-row
 * page of 400.
 */
export default function TablePagination({
  page = 1,
  totalPages = 1,
  total = 0,
  limit = 20,
  onPageChange,
  onLimitChange,
  limitOptions = [10, 20, 50],
}) {
  if (!total) return null;

  const first = (page - 1) * limit + 1;
  const last = Math.min(page * limit, total);

  return (
    <div className="mt-4 flex flex-wrap items-center justify-between gap-4 px-1">
      <p className="text-sm text-slate-600">
        Showing <span className="font-semibold">{first}</span>–
        <span className="font-semibold">{last}</span> of{" "}
        <span className="font-semibold">{total}</span>
      </p>

      <div className="flex items-center gap-4">
        {onLimitChange && (
          <label className="flex items-center gap-2 text-sm text-slate-600">
            Rows
            <select
              value={limit}
              onChange={(e) => onLimitChange(Number(e.target.value))}
              className="rounded-md border border-slate-300 bg-white px-2 py-1 text-sm focus:border-indigo-500 focus:outline-none"
            >
              {limitOptions.map((n) => (
                <option key={n} value={n}>
                  {n}
                </option>
              ))}
            </select>
          </label>
        )}

        <Pagination
          count={totalPages || 1}
          page={page}
          onChange={(_e, value) => onPageChange?.(value)}
          color="primary"
          shape="rounded"
          size="small"
        />
      </div>
    </div>
  );
}
